var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLonginBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 39,
    viewBox: "0 0 178 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 178,
    height: 39,
    rx: 10,
    fill: "#C0C0FD",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.06 26.3V27.08H61.18V26.3H69.14V22H62.5V16.5H75.98V12.58H62.5V11.8H76.82V17.28H63.34V21.22H77.12V22H69.98V26.3H78.06ZM95.9983 23.62H95.1583V12.56H81.5983V11.78H95.9983V23.62ZM97.2983 27.08H80.4183V26.3H97.2983V27.08ZM115.157 23.72H114.317V11H115.157V23.72ZM105.257 11.3C106.337 11.3 107.27 11.5133 108.057 11.94C108.857 12.3667 109.463 12.9467 109.877 13.68C110.29 14.4133 110.497 15.2333 110.497 16.14C110.497 17.0467 110.29 17.8667 109.877 18.6C109.463 19.3333 108.857 19.9133 108.057 20.34C107.27 20.7667 106.337 20.98 105.257 20.98C104.177 20.98 103.237 20.7667 102.437 20.34C101.65 19.9133 101.05 19.3333 100.637 18.6C100.223 17.8667 100.017 17.0467 100.017 16.14C100.017 15.2333 100.223 14.4133 100.637 13.68C101.05 12.9467 101.65 12.3667 102.437 11.94C103.237 11.5133 104.177 11.3 105.257 11.3ZM105.257 12.04C104.39 12.04 103.623 12.2133 102.957 12.56C102.29 12.8933 101.777 13.3733 101.417 14C101.057 14.6133 100.877 15.3267 100.877 16.14C100.877 16.9533 101.057 17.6733 101.417 18.3C101.777 18.9133 102.29 19.3933 102.957 19.74C103.623 20.0733 104.39 20.24 105.257 20.24C106.123 20.24 106.89 20.0733 107.557 19.74C108.223 19.3933 108.737 18.9133 109.097 18.3C109.457 17.6733 109.637 16.9533 109.637 16.14C109.637 15.3267 109.457 14.6133 109.097 14C108.737 13.3733 108.223 12.8933 107.557 12.56C106.89 12.2133 106.123 12.04 105.257 12.04ZM102.337 26.9H115.797V27.68H101.497V22.42H102.337V26.9Z",
    fill: "#EFEFF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLonginBtn);
export default __webpack_public_path__ + "static/media/LonginBtn.1b68331ec413462a73d791a06fb9cb1f.svg";
export { ForwardRef as ReactComponent };